import React from 'react';
import { LibraryItem } from './types';

type World = NonNullable<LibraryItem['world']>;
export const worldFields = [
  ['subtitle', 'World subtitle', 'Beach Kingdom'],
  ['vibe', 'The vibe', 'Sunny · Silly · Adventurous'],
  ['features', 'What you’ll find', 'Rainbow houses, giant palm trees, skateparks, warm beaches'],
  ['inhabitants', 'Who lives here', 'Surfers, friendly robots, talking dolphins'],
  ['happenings', 'What happens here', 'Treasure hunts, surfing contests, and sunset races'],
  ['landmark', 'Legendary landmark', '🏝️ The Golden Skatepark'],
  ['rule', 'One sentence description', 'A sunny beach kingdom where everyone travels by skateboard.'],
  ['sounds', 'Sounds like', '🌊 Waves · 🎵 Music · 🛹 Wheels'],
] as const;

export function worldFieldValue(world: World, key: typeof worldFields[number][0]): string {
  const legacy = { subtitle: world.setting, features: [world.obstacle, ...(world.details || [])].filter(Boolean).join(' · '), inhabitants: world.enemyName, happenings: world.enemyAction };
  return world[key] ?? (legacy as Record<string, string | undefined>)[key] ?? '';
}

export function WorldFields({ world, onChange }: { world: World; onChange: (world: World) => void }) {
  const frontKeys = ['vibe', 'landmark', 'rule'];
  const fields = (front: boolean) => worldFields.filter(([key]) => frontKeys.includes(key) === front).map(([key, label, placeholder]) => <label key={key}>{label}<textarea rows={key === 'subtitle' || key === 'vibe' ? 1 : 2} value={worldFieldValue(world, key)} placeholder={placeholder} onChange={event => onChange({ ...world, [key]: event.target.value })} /></label>);
  return <>
    <fieldset className="library-card-side"><legend>Front of card · World</legend>
      <p>The short introduction shown with the world artwork.</p>
      {['#38d9b5', '#69baff'].map((fallback, index) => <label key={index}>Atmosphere color {index + 1}<input type="color" value={world.colors?.[index] || fallback} onChange={event => { const colors = [world.colors?.[0] || '#38d9b5', world.colors?.[1] || '#69baff']; colors[index] = event.target.value; onChange({ ...world, colors }); }} /></label>)}
      {fields(true)}
    </fieldset>
    <fieldset className="library-card-side"><legend>Back of card · World details</legend>
      <p>The richer world information revealed when the card is flipped.</p>
      {fields(false)}
    </fieldset>
  </>;
}
